import { GenericModelApi } from "./GenericModelApi";
import { ApiClient, ApiError, ApiSchema, FetchResponse, NotFoundError } from "./ApiClient";
import { getTenantId } from "@utils/Auth";
import { ProviderNoteFormData, ProviderNoteRelatedAttributes } from "@/formTypes/ProviderNoteFormDataType";
import { ProviderNoteFormDataKeys } from "@/generated/ProviderNoteFormDataKeys";

export type ProviderNoteDataType = Partial<ApiSchema["ProviderNote"]["type"] & ProviderNoteFormData>;

class Api extends GenericModelApi<"ProviderNote", ProviderNoteDataType> {

    async fetchAll(filters: any = {}, token?: string, limit: number = 20): Promise<FetchResponse<ProviderNoteDataType>> {
        const selectionSet = [
            ...ProviderNoteFormDataKeys.filter(k => !ProviderNoteRelatedAttributes.includes(k)),
            "currency.*",
        ]
        return super.fetchAll(filters, token, limit, selectionSet);
    }

    async getProviderNoteByDocumentKey(
        documentKey: string,
        selectionSet?: any
    ): Promise<ProviderNoteDataType> {
        const tenantId = await getTenantId();

        const collected: ProviderNoteDataType[] = [];

        const fetchFunction = ApiClient.models[this.modelName].listProviderNoteByDocumentKeyTenant;
        const { data, errors, nextToken: nt } = await fetchFunction({
            owner: tenantId,
            document_key: { eq: documentKey },
        }, {
            limit: 1,
            selectionSet: selectionSet,
        });

        if (errors) {
            throw new ApiError("Error al obtener la Nota de Credito del provedor", "API_ERROR", errors);
        }

        const pageItems = (data || [])
        if (pageItems.length > 0) {
            return pageItems[0]
        }

        throw new NotFoundError(`No existe ninguna Nota de Credito del provedor con el codigo la clave ${documentKey} `, "API_ERROR", errors);
    }
}
export const ProviderNoteApi = new Api("ProviderNote", "numero")